import React, { useState } from "react";
import "../Privacy_Policy/Privacy_Policy.css";
import { Link } from "react-router-dom";


export default function Privacy_Policy() {



  return (

    <div className="Privacy_Policy-page">
      <div className="Privacy_Policy-hero">
        <div className="Privacy_Policy-overlay">
          <h1>מדיניות פרטיות</h1>
        </div>
<div>
</div>
</div>
    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/Privacy_Policy">  מדיניות פרטיות</Link>{" "}

</div>
    </div>

      {/* CONTENT */}
<div className="page4">
  <div className="container">

    <h2 className="top-text">
כללי


    </h2>

    <div className="content-row">


      <div className="text-box">
        <p> אנו באתר זה נוהגים בכבוד מירבי לפרטיות משתמשי האתר. מטרתם של התנאים הבאים להבהיר לגולש את מדיניות הפרטיות הנהוגה באתר לרבות תיאור אופן השימוש של מפעילי האתר במידע, איסופו ושימושיו.

</p>
      </div>

    </div>

    <h2 className="main-title">
שינויים במדיניות הפרטיות

    </h2>

    <div className="bottom-text">
      <p>מפעילי האתר רשאים לערוך, לשנות מעת לעת את מדיניות הפרטיות באתר. כאשר יבוצע שינוי מהותי ויסודי בתנאים הנוגעים לשימוש במידע אישי שנמסר על ידי הגולשים, תפורסם על כך הודעה בדף הבית של האתר.

</p>




  <h2 className="main-title">
שימוש במידע


    </h2>



<div style={{ direction: 'rtl', textAlign: 'right', fontFamily: 'Arial, sans-serif', color: '#1a1a1a', fontSize: '14px', lineHeight: '1.6', maxWidth: '800px', margin: '20px auto', padding: '0 15px' }}>
  
  <p style={{ marginBottom: '15px' }}>
    מערכת האתר שומרת מקצת מן המידע במאגריה ועושה בהם שימוש בכפוף לתנאי מדיניות הפרטיות ואו פי הוראות כל דין. זאת לצורך מטרות אלה ואחרות:
  </p>

  {/* רשימת הסעיפים באמצעות דיבים ופסקאות */}
  {[
    "לצורך שימוש הגולש בשירותים ייחודיים כדוגמת תגובות לכתבות, פורומים, משחקים, מבצעים ופעילויות שונות המוצעות באתר.",
    "לצורך שיפור, תפעול ופיתוח האתר לרבות לצורך ניתוח הרגלי צפייה וגלישה שיאפשרו למפעילי האתר לשפר את תכניות ומבנהו של האתר לנוחיות ושימושיות הגולש, ועל מנת להציע לו הצעות, מידע ושירותים מותאמים אישית לצרכיו והעדפותיו או המותאמים לקבוצות עניין העושות שימוש באתר. לרוב, ניתוח המידע הינו סטטיסטי ואינו מזהה את הגולש באופן אישי.",
    "לצורך פרסום מידע, רכישה ומכירה של שירותים ומוצרים באתר כולל פרסום מודעות באזורים המוקדשים לכך באופן ייעודי.",
    "לצורך התאמה אישית של מודעות פרסומיות שיוצגו לגולש בעת גלישתו באתר, המותאמות לתחומי העניין הספציפיים של הגולש. מידע זה לרבות פרטים שתשאיר באופן פעיל באתר, יכול ויאסף על ידי מפעילי האתר או על ידי המפרסמים באתר בדרכים שונות.",
    "לצורך פנייה אישית אל הגולש לצורך פרסום או במקרה הצורך או בהתאם לנדרש על פי כל דין או במקרה ותופר מי מהוראות הסכם השימוש באתר או מדיניות הפרטיות או כל תנאי אחר המצוין באתר באשר למידע או שירות בו השתמשת או במקרה מחלוקת עם הגולש.",
    "לצורך איסוף מידע כללי או פרטני ואו ניתוח ומסירת מידע סטטיסטי לצדדים שלישיים, לרבות מפרסמים אולם באופן שלא יזהה את הגולש באופן אישי.",
    "לצורך מטרות אחרות שיפורטו במדיניות פרטיות זו או בתנאי שימוש אחרים באתר שיעודכנו מעת לעת.",
    "מערכת האתר מתחייבת לנהוג במידע שנאסף אודות הגולשים בהתאם ובכפוף למגבלות כל דין."
  ].map((text, index) => (
    <div key={index} style={{ position: 'relative', paddingRight: '20px', marginBottom: '12px' }}>
      <span style={{ position: 'absolute', right: '0', top: '0', fontSize: '16px', fontWeight: 'bold' }}>•</span>
      <p style={{ margin: '0' }}>{text}</p>
    </div>
  ))}

</div>




  <h2 className="main-title">
עוגיות

    </h2>



      <p>קובץ Cookie הוא קובץ קטן אשר מבקש רשות להיות ממוקם על הכונן הקשיח של המחשב. ברגע שאתה מסכים, הקובץ מנתח את תעבורת האינטרנט או מאפשר לך לדעת מתי אתה מבקר באתר מסוים. עוגיות מאפשרות ליישומי אינטרנט לטפל בך בתור משתמש ייחודי, או אדם פרטי. יישום אינטרנט יכול להתאים את פעילותו לפי העדפותיך, ומפעיל איסוף מידע על מנת לזכור את ההעדפות שלך.

 </p>

            <p>אתר זה משתמש בתוכנת סטטיסטיקה לאתרים, המזהה אילו דפים נמצאים בשימוש. כמו כן, אתר זה נעזר בשירות הפעלת קבצי Cookies כדי להגיש פרסומות והצעות שיווקיות מיוחדות. השימוש בקבצי Cookie עוזר לנו לנתח נתונים על תעבורת האינטרנט ולשפר את אתר האינטרנט שלנו על מנת להתאים אותו לצורכי הלקוח. אנו משתמשים במידע זה רק למטרות ניתוח סטטיסטי ופילוח שיווקי, והסטטיסטיקות של האתר או מבצעי הפרסום אינם מזהים אותך לעולם באופן אישי כאדם או כמשתמש.

</p>

      <p> בסך הכל, קבצי 'עוגיות' מסייעים לנו לספק לך אתר טוב יותר, בכך שהם מאפשרים לנו לעקוב אחר הדפים שאותם אתה מוצא שימושיים, ולהציע לך מבצעים הרלוונטיים לך. קובץ העוגיה בשום פנים ואופן אינה נותנת לנו גישה למחשב שלך או כל מידע אודותיך, מלבד הנתונים שאותם תבחר לשתף אותנו בצורה פעילה - כמו למשל באמצעות מילוי טופס התקשרות באתר.

 </p>



      <p> אתה יכול לבחור אם לקבל או לדחות קבצי Cookie. רוב דפדפני האינטרנט מקבלים קבצי Cookie באופן אוטומטי, אך ניתן בדרך כלל לשנות את הגדרת הדפדפן כדי לסרב לקבל קבצי Cookie, אם הנך מעדיף זאת. זה עשוי למנוע ממך להנות ממלוא היתרונות באתר. כמו כן, תוכל להשתמש בעמודי מידע כדי לבצע הסרת מודעות בלתי רצויות.


 </p>




 <h2 className="main-title">
מה אנו אוספים



    </h2>

<div style={{ direction: 'rtl', textAlign: 'right', fontFamily: 'Arial, sans-serif', color: '#1a1a1a', fontSize: '14px', lineHeight: '1.6', maxWidth: '800px', margin: '20px auto', padding: '0 15px' }}>
  
  <p style={{ marginBottom: '15px' }}>
    אנו עשויים לאסוף את המידע הבא:
  </p>

  {/* רשימת הסעיפים באמצעות דיבים ופסקאות */}
  {[
    "שם פרטי ומשפחה",
    "פרטים ליצירת קשר כולל כתובת דוא\"ל",
    "מידע על הזמנות ורכישות",
    "מידע סטטיסטי על דפוסי גלישה באתר",
    "מידע הקשור בשירות לקוחות ומכירות (פניות, בקשות, הצעות, תלונות ובירורים)"
  ].map((text, index) => (
    <div key={index} style={{ position: 'relative', paddingRight: '20px', marginBottom: '12px' }}>
      <span style={{ position: 'absolute', right: '0', top: '0', fontSize: '16px', fontWeight: 'bold' }}>•</span>
      <p style={{ margin: '0' }}>{text}</p>
    </div>
  ))}

</div>


<h2 className="main-title">
מה אנחנו עושים עם המידע שאנו אוספים



    </h2>


<div style={{ direction: 'rtl', textAlign: 'right', fontFamily: 'Arial, sans-serif', color: '#1a1a1a', fontSize: '14px', lineHeight: '1.6', maxWidth: '800px', margin: '20px auto', padding: '0 15px' }}>
  
  <p style={{ marginBottom: '15px' }}>
    אנו אוספים מידע זה כדי להבין את הצרכים שלך ולספק לך שירות טוב יותר, ובעיקר מהסיבות הבאות:
  </p>

  {/* רשימת הסעיפים באמצעות דיבים ופסקאות */}
  {[
    "שמירה על נתונים עבור פניות עתידיות.",
    "עדכון על מבצעים חודשיים או תקופתיים באתר ובחנויות הרשת.",
    "שמירה על נתוני עסקאות-עבר עבור משלוחים, חיובים, אחריות, הנחות, מבצעים וכדומה.",
    "כדי לשפר את המוצרים והשירותים שלנו.",
    "כדי לשלוח הודעות דוא\"ל פרסומי על מוצרים חדשים, הצעות מיוחדות או כל מידע אחר שאנו חושבים שאתה יכול למצוא עניין באמצעות כתובת דוא\"ל אשר סיפקת.",
    "כדי ליצור איתך קשר למטרות שירות לקוחות ו/או מחקרי שוק. אנו עשויים לפנות אליך באמצעות פקס, דואר ישראל, טלפון או דואר אלקטרוני.",
    "כדי להציע לך מוצרים ושירותים מותאמים-אישית, ואולי גם להתאים אישית את האתר על פי הצרכים והרצונות שלך."
  ].map((text, index) => (
    <div key={index} style={{ position: 'relative', paddingRight: '20px', marginBottom: '12px' }}>
      <span style={{ position: 'absolute', right: '0', top: '0', fontSize: '16px', fontWeight: 'bold' }}>•</span>
      <p style={{ margin: '0' }}>{text}</p>
    </div>
  ))}

</div>






<h2 className="main-title">
אבטחת מידע




    </h2>


      <p>   אנו מחויבים להבטיח כי המידע שלך מאובטח. על מנת למנוע גישה אסורה לנתונים אישיים, אנו פועלים בהתאם לנהלים פיזיים, פיננסיים, אלקטרוניים וניהוליים עדכניים כדי להגן ולאבטח את המידע שאנו אוספים באופן מקוון.

 

 </p>



<h2 className="main-title">
פרסומות באתר




    </h2>


      <p>    מערכת האתר מפעילה מערך פרסומות ותכנים עצמאי. בנוסף, המערכת מאפשרת ועשויה לאפשר לצדדים שלישיים אחרים לנהל ולתפעל את מערך הפרסומות באתר ואו מערכי תוכן ושירותים. במסגרת זו יתכן ויצפה הגולש בהצעות שירות, תכנים, מידע או בפרסומות של האתר או של גורמים שלישיים כלשהם- מידע או מודעות שמקורן במפרסמים חיצוניים האוספים מידע אודות הגולש לרבות באמצעות שתילת עוגיות Cookies במחשב הגולש. זאת בין השאר לצורך ניתוח מידע, התאמת פרסומות וניתוח צרכי הגולש. שימוש זה נעשה בהתאם למדיניות הפרטיות ותנאי השימוש של אתרים אלו ואינו נוגע למדיניות הפרטיות של אתר הידען. אם הגולש מעוניין למנוע פעילות מעין זו, עליו לפעול באופן פרטני על מנת למנוע איסוף מידע כזה על ידי גורמים שלישיים אלו לרבות מפרסמים.

 
 </p>



<h2 className="main-title">
חוק הגנת הפרטיות




    </h2>



      <p> על-פי חוק הגנת הפרטיות, התשמ"א – 1981 הגולש רשאי לעיין במידע, כשמידע זה מוחזק במאגר מידע כהגדרתו בחוק. המידע הנאסף אודותיך על ידי מפעילי האתר במסגרת פעילות ממוקדת או אגב אורחא, כפוף לחוק זה ולפיכך לכל זכויות ודרישות הגולש וכל מאן דבעי, בהתאם לכל דין.




 </p>


      <p> במהלך שימוש הגולשים באתר יתכן וייאסף מידע אודות המשתמש-הגולש, הרגלי גלישתו באתר, שירותים ומוצרים שנרכשו על ידו באתר, הצעות ושירותים, פרסומות ונושאי עניין שלו, מוצרים שביקש למכור או לרכוש, עמודי מידע בהם ביקר, רישום לשירותים מיוחדים המצריכים רישום, הצעות ושירותים שעניינו אותך, אמצעי התשלום בהם נעשה שימוש על ידי הגולש בהקשר ישיר או עקיף עם האתר ועוד. הגולש אינו חייב למסור כל מידע ולגלוש באתר ולאפשר איסוף נתונים אודותיו אולם בגולשו באתר הינו מסכים לאסוף המידע בכפוף לשימוש בו לפי הוראות כל דין. יתכן כי לגבי שירותים מסוימים לא יוכל לגלוש באתר ולהנות משירותים אלה ללא העברת מידע.



 </p>







    </div>




      </div>
    </div>
  

      </div>
  );
}

